@if (product) {
<div class="pos-absolute bottom-2 right-2 left-2 pe-none z-6 right _wrapper">
    <div class="inline-block pe-auto _inner">
        @if (showOptions) {
        <product-listing-wishlist-configurable-options class="pos-absolute top-0 right-0 bottom-0 z-1 ng-hide-animate"
                                                       [ngClass]="!showOptions ? 'ng-hide pe-none' : ''"
                                                       [product]="product"
                                                       [color]="color"
                                                       [listPosition]="listPosition" />
        }

        <wishlist-message class="pos-absolute top-0 right-0 bottom-0 z-2 ng-hide-animate"
                          [ngClass]="showOptions ? 'ng-hide pe-none' : ''"
                          [product]="product"
                          [listPosition]="listPosition" />
    </div>
</div>
}